/*
  Black Moon Alchemy
  Daniel Su
  Last updated: 2022/7/1
*/
import "core-js/stable";
import "regenerator-runtime/runtime";
import $ from 'jquery';
import UIkit from 'uikit';
import ScrollReveal from 'scrollreveal';
import "jquery-touchswipe/jquery.touchSwipe";

/* Scrollreveal */
/*ScrollReveal().watch = function (target, onEnter, onExit) {
	onExit = onExit || function () {}
	if (typeof onEnter === 'function' && typeof onExit === 'function') {
		var noEffect = {
			delay: 0, duration: 500, distance: '40px', easing: 'cubic-bezier(.5,0,0,1)', origin: 'bottom', reset: true, scale: 1, viewFactor : 0,
			beforeReset: onExit,
			beforeReveal: onEnter,
		}
		this.reveal(target, noEffect)
	} else {
		throw new Error('Watch received invalid arguments.')
	}
}
(function ScrollReveal() {
  ScrollReveal.debug = true;
  window.sr = ScrollReveal();
  const fadeDownOption = { delay: 0, duration: 1000, distance: '80px', easing: 'cubic-bezier(.5,0,0,1)', origin: 'bottom', reset: true, scale: 1, viewFactor : 0 };
  const fadeUpOption = { delay: 0, duration: 1000, distance: '80px', easing: 'cubic-bezier(.5,0,0,1)', origin: 'top', reset: true, interval: 60 };
  const fadeRightOption = { delay: 0, duration: 0, distance: '0', easing: 'cubic-bezier(.5,0,0,1)', origin: 'right',reset: true,viewOffset:{top:-200}};

  //sr.reveal('#global-footer .content, #main .content', fadeDownOption);
        //sr.reveal('#main .reveal-item-right', fadeRightOption);
  sr.reveal('.text-wrap', fadeUpOption);

  ScrollReveal().watch('#global-footer .content, #main .layout',
    function onEnter (el) {
      el.classList.add('srevealed')
    },
    function onExit (el) {
      el.classList.remove('srevealed')
    }
  )
})();*/

$(() => {

  /* SrollReveal */
  ScrollReveal.debug = false;
  const fadeDownOption = { delay: 0, duration: 1000, distance: '80px', easing: 'cubic-bezier(.5,0,0,1)', origin: 'bottom', reset: false, scale: 1, viewFactor : 0.1 };
  ScrollReveal().reveal('.text-wrap, .tabs-wrap, .footer-container', fadeDownOption);

  /* Adjust vh when resize window */
  window.addEventListener('resize', () => {
    // We execute the same script as before
    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
  });

  /* Scroll functions */
  window.addEventListener('scroll', () => {
    var scroll_top = window.scrollY;
    var totop = document.querySelector('#to-top');
    var header = document.querySelector('#global-header');
    if (scroll_top >= 500) {
        totop.classList.add('show');
    } else {
        totop.classList.remove('show');
    }
    if(scroll_top > 10) {
        header.classList.add('sticky');
    }else{
        header.classList.remove('sticky');
    }
  });

  /* Menu open */ 
  document.getElementById('memu-btn').addEventListener('click', () => {
    document.querySelector('body').classList.toggle('menu-open');
  }); 
  
  /* Go To Top */
  document.getElementById('to-top').addEventListener('click',() => {
    window.scrollTo({top:0,behavior:'smooth'});
  });
  /* Slider Function */
  var slider_nav = document.querySelectorAll('.slider-nav');
  [...slider_nav].forEach(function (item) {
      item.addEventListener('click', () => {
          var slide_length = item.parentNode.parentNode.querySelectorAll('.uk-slideshow-item').length;
          var current_slide = item.parentNode.parentNode.querySelector('.uk-slideshow-items li.uk-active').getAttribute('data-index');
          var text_slide = item.parentNode.parentNode.parentNode.querySelectorAll('.image-credit');
          [...text_slide].forEach(function (item) {
              item.classList.remove('credit-active');
          });
          if (item.classList.contains('slider-nav-next') || item.classList.contains('text-nav-next')) {
              if (current_slide < slide_length) {
                  document.querySelector('#credit-' + (Number(current_slide) + 1)).classList.add('credit-active');
              } else if (current_slide == slide_length) {
                  document.querySelector('#credit-1').classList.add('credit-active');
              }
          } else {
              if (current_slide > 1) {
                  document.querySelector('#credit-' + (Number(current_slide) - 1)).classList.add('credit-active');
              } else if (current_slide == 1) {
                  document.querySelector('#credit-' + slide_length).classList.add('credit-active');
              }
          }
      });
  });

  if( $('.card').length){
    $('.card').on('click', function(){
      let index = $(this).data('index');
      UIkit.slideshow(document.querySelector('#modal-slider')).show(index);
    });
  }

  // On opening of grid gallery
  if($('.gallery-item')){
      $('.gallery-item').on('click', function () {
        var $currentIndex = parseInt($(this).find('img').data('index'));
        var $image = $(this).find('img').attr('src');

        $('#lightbox').attr('data-current-index', $currentIndex);
       // showHideArrows($currentIndex, $galleryCount);
    
        var elem = document.createElement("img");
        elem.src = $image;
    
        $("#lightbox .image-container").append(elem);
        $('#lightbox').addClass('active');
        $('body').addClass('overflow-hidden');
      });
  }

  function nextImage () {
    var $nextIndex = parseInt($('#lightbox').attr('data-current-index')) + 1;
    var $galleryCount = parseInt($('.gallery-item:last-child').find('img').data('index'));
    if ($nextIndex > $galleryCount) {
      $nextIndex = 0
    }
    $('#lightbox .gallery-index').text($nextIndex + 1);
    $('#lightbox').attr('data-current-index', $nextIndex);
    changeImage($nextIndex);
  }
  function prevImage () {
    var $prevIndex = parseInt($('#lightbox').attr('data-current-index')) - 1;
    var $galleryCount = parseInt($('.gallery-item:last-child').find('img').data('index'));
    if ($prevIndex < 0) {
      $prevIndex = $galleryCount;
    }
    $('#lightbox .gallery-index').text($prevIndex + 1);
    $('#lightbox').attr('data-current-index', $prevIndex);
    changeImage($prevIndex);
  }

  $('#lightbox .close').on('click', function () {
    $('#lightbox').removeClass('active');
    $('#lightbox img').remove();
    $('body').removeClass('overflow-hidden');
  })

  function changeImage ($index) {
    var $image = $('.gallery-wrap').find('img[data-index="' + $index + '"]').attr('data-image');
    $("#lightbox .image-container img").remove();
    var elem = document.createElement("img");
    elem.src = $image;

    $("#lightbox .image-container").append(elem);
  }
  // On next, prev click
  $('#lightbox .next').on('click', nextImage)
  $('#lightbox .prev').on('click', prevImage)

  $("#lightbox .image-container").swipe( {
    //Generic swipe handler for all directions
    swipe:function(event, direction, distance, duration, fingerCount, fingerData) {
      if (direction === 'left') {
        nextImage()
      }
      if (direction === 'right') {
        prevImage()
      }
      return
    },
    //Default is 75px, set to 0 for demo so any distance triggers swipe
     threshold:30
  });

  /* Menu Tab Open */
  if(window.location.search != ''){
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const tab = urlParams.get('t');
    if($("#"+tab).length){
      $(".tab-heading").removeClass("uk-active");
      $("#"+tab).addClass("uk-active");
      $(".uk-accordion").removeClass("uk-active");
      $("#body-"+tab).addClass("uk-active");
    }
  }

});

(function googleMapInit() {

/**
 * initMap
 *
 * Renders a Google Map onto the selected jQuery element
 *
 * @date    22/10/19
 * @since   5.8.6
 *
 * @param   jQuery $el The jQuery element.
 * @return  object The map instance.
 */
function initMap($el) {

  // Find marker elements within map.
  var $markers = $el.find('.marker');

  // Create gerenic map.
  var mapArgs = {
      zoom: $el.data('zoom') || 12,
      mapTypeId: google.maps.MapTypeId.ROADMAP,
      disableDefaultUI: true,
      mapTypeControl: false,
      styles: [{"featureType":"all","elementType":"labels.text.fill","stylers":[{"saturation":36},{"color":"#000000"},{"lightness":40}]},{"featureType":"all","elementType":"labels.text.stroke","stylers":[{"visibility":"on"},{"color":"#000000"},{"lightness":16}]},{"featureType":"all","elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"featureType":"administrative","elementType":"geometry.fill","stylers":[{"color":"#000000"},{"lightness":20}]},{"featureType":"administrative","elementType":"geometry.stroke","stylers":[{"color":"#000000"},{"lightness":17},{"weight":1.2}]},{"featureType":"landscape","elementType":"geometry","stylers":[{"color":"#000000"},{"lightness":20}]},{"featureType":"poi","elementType":"geometry","stylers":[{"color":"#000000"},{"lightness":21}]},{"featureType":"road.highway","elementType":"geometry.fill","stylers":[{"color":"#000000"},{"lightness":17}]},{"featureType":"road.highway","elementType":"geometry.stroke","stylers":[{"color":"#000000"},{"lightness":29},{"weight":0.2}]},{"featureType":"road.arterial","elementType":"geometry","stylers":[{"color":"#000000"},{"lightness":18}]},{"featureType":"road.local","elementType":"geometry","stylers":[{"color":"#000000"},{"lightness":16}]},{"featureType":"transit","elementType":"geometry","stylers":[{"color":"#000000"},{"lightness":19}]},{"featureType":"water","elementType":"geometry","stylers":[{"color":"#000000"},{"lightness":17}]}],
      //styles: [{"featureType":"administrative","elementType":"labels.text.fill","stylers":[{"color":"#444444"}]},{"featureType":"landscape","elementType":"all","stylers":[{"color":"#f2f2f2"}]},{"featureType":"poi","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"road","elementType":"all","stylers":[{"saturation":-100},{"lightness":45}]},{"featureType":"road.highway","elementType":"all","stylers":[{"visibility":"simplified"}]},{"featureType":"road.highway","elementType":"geometry.fill","stylers":[{"color":"#ffffff"}]},{"featureType":"road.arterial","elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"featureType":"transit","elementType":"all","stylers":[{"visibility":"off"}]},{"featureType":"water","elementType":"all","stylers":[{"color":"#dde6e8"},{"visibility":"on"}]}],
  };
  var map = new google.maps.Map($el[0], mapArgs);

  // Add markers.
  map.markers = [];
  $markers.each(function () {
      initMarker($(this), map);
  });

  // Center map based on markers.
  centerMap(map);

  console.log(map);

  // Return map instance.
  return map;
}

/**
* initMarker
*
* Creates a marker for the given jQuery element and map.
*
* @date    22/10/19
* @since   5.8.6
*
* @param   jQuery $el The jQuery element.
* @param   object The map instance.
* @return  object The marker instance.
*/
function initMarker($marker, map) {

  // Get position from marker.
  var lat = $marker.data('lat');
  var lng = $marker.data('lng');
  var address = $marker.data('address');
  var latLng = {
      lat: parseFloat(lat),
      lng: parseFloat(lng)
  };

  var icon = {
      url: "/wp-content/themes/tutaki/src/images/tutaki-logo-rev.svg",
      anchor: new google.maps.Point(30, 30),
      scaledSize: new google.maps.Size(100, 100)
  }

  // Create marker instance.
  var marker = new google.maps.Marker({
      position: latLng,
      map: map,
      icon: icon,
      title:'Tutaki Location'
  });

  var infoWindow = new google.maps.InfoWindow({
    content: '<sapn>Click the logo to see more in google map.</sapn>'
  });
  
  // Add a click event listener to the marker
  marker.addListener('click', function() {
    window.open('https://www.google.com/maps/search/?q=' + address, '_blank');
  });

  marker.addListener('mouseover', function() {
    infoWindow.open(map, marker);
  });

  marker.addListener('mouseout', function() {
    infoWindow.close();
  });

  // Append to reference for later use.
  map.markers.push(marker);

  // If marker contains HTML, add it to an infoWindow.
  if ($marker.html()) {

      // Create info window.
      var infowindow = new google.maps.InfoWindow({
          content: $marker.html()
      });

      // Show info window when marker is clicked.
      google.maps.event.addListener(marker, 'click', function () {
          infowindow.open(map, marker);
      });
  }
}

/**
* centerMap
*
* Centers the map showing all markers in view.
*
* @date    22/10/19
* @since   5.8.6
*
* @param   object The map instance.
* @return  void
*/
function centerMap(map) {

  // Create map boundaries from all map markers.
  var bounds = new google.maps.LatLngBounds();
  map.markers.forEach(function (marker) {
      bounds.extend({
          lat: marker.position.lat(),
          lng: marker.position.lng()
      });
  });

  // Case: Single marker.
  if (map.markers.length == 1) {
      map.setCenter(bounds.getCenter());

      // Case: Multiple markers.
  } else {
      map.fitBounds(bounds);
  }
}

// Render maps on page load.
  if($('.acf-map').length){
    $('.acf-map').each(function () {
        var map = initMap($(this));
    });
  }

})();
